import {createAction, props} from '@ngrx/store';
import {Boleto} from '../../models';

export enum ActionsBoleto {
  POST_BOLETO = '[Boleto-POST] Post Boleto',
  POSTED_BOLETO = '[Boleto-POST] Posted success',
  CLEAR_BOLETO = '[Boleto-CLEAR] Clear',

}

export const postBoleto = createAction(
  ActionsBoleto.POST_BOLETO,
  props<{ boleto: Boleto }>()

);

export const postedBoleto = createAction(
  ActionsBoleto.POSTED_BOLETO,
  props<{ boleto: Boleto }>()
);


export const clearBoleto = createAction(
  ActionsBoleto.CLEAR_BOLETO
)

